import { render, staticRenderFns } from "./SideBarUserPanel.vue?vue&type=template&id=5a800108&"
import script from "./SideBarUserPanel.vue?vue&type=script&lang=js&"
export * from "./SideBarUserPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a800108')) {
      api.createRecord('5a800108', component.options)
    } else {
      api.reload('5a800108', component.options)
    }
    module.hot.accept("./SideBarUserPanel.vue?vue&type=template&id=5a800108&", function () {
      api.rerender('5a800108', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/SideBarUserPanel.vue"
export default component.exports